//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      quesImgOpt: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        swipe: false,
        //asNavFor: "#ques-ans-slider",
        infinite: false,
        slidesToScroll: 1,
      },
      slideChangeStatus: 0,
      currentQuesIndex: 0,
      answers: [],
    };
  },
  mounted() {
    this.$store.dispatch("tea-products/getQuizDetails");
  },
  computed: {
    quiz() {
      return this.$store.state["tea-products"].teaQuizData;
    },
    currentQues() {
      if (this.quiz != null) {
        return this.quiz[this.currentQuesIndex];
      } else {
        null;
      }
    },
  },
  watch: {
    quiz(val) {
      if (val != null) {
        this.answers = val.map(() => "");
      }
    },
  },

  methods: {
    clearFilteredItem() {
      this.$store.commit("tea-products/CLEAR_TEAQUIZ_RESULT");
    },
    showProducts() {
      let data = {
        page: 1,
        size: 20,
        teaType: this.answers[0],
        caffeinePreference: this.answers[1],
        time: this.answers[2],
      };
      this.$router.push({
        path: "/our-products/our-teas-recommendation",
        query: data,
      });
    },
    skipQues() {
      if (this.currentQuesIndex + 1 == this.answers.length) {
        this.showProducts();
      } else {
        this.answers[this.currentQuesIndex] = "";
        this.$refs["ques-img-slider"].next();
      }
    },
    onQuestionChange(e, slick, current, next) {
      this.slideChangeStatus = 1;
      setTimeout(() => {
        this.currentQuesIndex = next;
      }, 200);
    },
  },
};
